import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AdminAuthService } from './admin-auth.service';

export const adminGuard: CanActivateFn = () => {
  const adminAuth = inject(AdminAuthService);
  const router = inject(Router);
  if (adminAuth.isAdminLoggedIn()) {
    return true;
  }
  router.navigate(['/admin/login']);
  return false;
};
